import { getErrorByFailureAction } from "../../intl/shared-resources/serverResponse.js";
import { of, from } from "rxjs";
import { filter, bufferTime, groupBy, reduce } from "rxjs/operators";
import { isActionOf } from "typesafe-actions";
import "react";
import "react-oidc-context";
import "react-router";
import { AuthorizationLevel } from "../../auth/types.js";
import "oidc-client-ts";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react-error-boundary";
import { switchMap, mergeMap, map } from "../../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import { BaseEpicsBuilder } from "../epicsBuilder.js";
import "../actions.js";
import { actions } from "../async-action/action.js";
import "react-redux";
import "moment-timezone";
import { nameOf } from "../../utils/object.js";
import "react-intl";
import { asyncActions } from "./actions.js";
import { RequestStatus } from "./types.js";
class AsyncActionEpicsBuilder extends BaseEpicsBuilder {
  constructor(actions2, _userManagement) {
    super();
    this._userManagement = _userManagement;
    this._actions = [];
    this._successActionMapping = {};
    this._failureActionMapping = {};
    const asyncActions2 = this.filterAsyncActions(actions2);
    for (const action of asyncActions2) {
      if (action !== null) {
        this._actions.push(action);
        this._successActionMapping[action.success().type] = action.request().type;
        this._failureActionMapping[action.failure().type] = action.request().type;
      }
    }
  }
  _actions;
  _successActionMapping;
  _failureActionMapping;
  buildEpicList() {
    const inProgressEpic = (action$) => action$.pipe(
      filter(isActionOf(this._actions.map((a) => a.request))),
      switchMap((action) => {
        return of(
          asyncActions.setRequestStatus({
            actionType: action.type,
            actionId: action.meta?.actionId,
            requestStatus: RequestStatus.Progress
          })
        );
      })
    );
    const successEpic = (action$) => action$.pipe(
      filter(isActionOf(this._actions.map((a) => a.success))),
      switchMap((action) => {
        const actionType = this._successActionMapping[action.type];
        const actionId = action.meta?.actionId;
        return of(
          asyncActions.setRequestStatus({ actionType, actionId, requestStatus: RequestStatus.None }),
          asyncActions.setSuccessResponse({ actionType, actionId, response: action.payload })
        );
      })
    );
    const failedEpic = (action$) => action$.pipe(
      filter(isActionOf(this._actions.map((a) => a.failure))),
      switchMap((action) => {
        const actionType = this._failureActionMapping[action.type];
        const errorMessage = getErrorByFailureAction(action.type, action.payload?.code ?? action.payload?.errors?.[0]?.code);
        const actionId = action.meta?.actionId;
        return of(
          asyncActions.setRequestStatus({ actionType, actionId, requestStatus: RequestStatus.Error }),
          asyncActions.setErrorMessage({
            actionType,
            actionId,
            errorMessage
          })
        );
      })
    );
    return [inProgressEpic, successEpic, failedEpic, this.buildUnuseAsyncActionEpic(), this.buildRedirectEpic()];
  }
  buildRedirectEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(actions.redirectStepUp)),
      switchMap(({ payload }) => {
        this._userManagement?.signinRedirect({
          acr_values: `${payload.expectedAcr ?? AuthorizationLevel.Password}`,
          redirect_uri: location.href
        });
        return of();
      })
    );
  }
  buildUnuseAsyncActionEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(asyncActions.unuseAsyncAction)),
      bufferTime(200),
      filter((actions2) => actions2.length > 0),
      mergeMap((actions2) => {
        return from(actions2).pipe(
          map((action) => action.payload),
          groupBy((p) => p.actionType),
          mergeMap(
            (actionType$) => actionType$.pipe(reduce((_, current) => current.actionType, ""))
          ),
          map((actionType) => {
            return asyncActions.clearAsyncActionsState({ actionType });
          })
        );
      })
    );
  }
  filterAsyncActions(actions2) {
    const keys = Object.keys(actions2);
    return keys.map((key) => actions2[key]).flatMap((a) => {
      const keys2 = Object.keys(a);
      const isAsyncAction = keys2.includes(nameOf("request"));
      const isAction = a instanceof Function;
      return isAsyncAction ? a : isAction ? null : this.filterAsyncActions(a);
    });
  }
}
export {
  AsyncActionEpicsBuilder
};
//# sourceMappingURL=epics.js.map
